import { ApiOperationItems } from "~enums/apiOperationItems.ts";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { ensureDefaultOperationResponse, isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { useGenerateReport } from "./useGenerateReport.ts";

export const useReportService = () => {
  const { mutateAsync: generateReportFn, isPending: isGeneratePending } = useGenerateReport();
  const { execute } = useApiOperations(ApiOperationItems.REPORT);

  const generateReport = async (url: string, successMessageId: string): Promise<DefaultOperationSuccessResponse> =>
    ensureDefaultOperationResponse(
      await execute(() => generateReportFn(url), {
        successMessageId,
        isSucceeded: isDefaultOperationSucceeded,
      }),
      "Report generation was not started",
    );

  return {
    generateReport,
    isGeneratePending,
  };
};
